import { Action } from '../../config';

export default interface NetworkSettable {
  setNetworkContext(network: string, action: Action): void;
}

export function isNetworkSettable(object: unknown): object is NetworkSettable {
  return (<NetworkSettable>object).setNetworkContext !== undefined;
}
